/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    const { page = 1, sort = 'due_at', direction = 'asc', ...filters } = params;
    const searchParams = new URLSearchParams({ page, sort, direction });

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value);
      }
    });

    return axios.get(`${this.url}?${searchParams.toString()}`);
  }
}

export default new TasksAPI();
